import { css } from '@emotion/react'
import { Theme, useTheme } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import {
  SimNaoRadioGroupListField,
  SimNaoRadioGroupListFieldProps,
} from 'components/form/field/SimNaoRadioGroupListField'
import { MetaPath, MetaRoot } from 'util/metaPath'

import { ConsultaSeguimentoOutroFieldModel } from '../model-consultaSeguimento'
import { PerguntaSimNaoOutroRadioListField } from './PerguntaSimNaoOutroRadioListField'

type PerguntaSimNaoRadioListFieldProps<T extends string> = Omit<
  SimNaoRadioGroupListFieldProps<T>,
  'labelStyle' | 'name'
> & {
  name: MetaPath<Record<T, SimNaoEnum | undefined>> & MetaRoot<Record<T, SimNaoEnum>>
  nameOutro?: MetaPath<ConsultaSeguimentoOutroFieldModel>
  hideOutrosFieldRadioOptions?: boolean
  onOutroFieldBlur?: () => void
}

export function PerguntaSimNaoRadioListField<T extends string>(props: Readonly<PerguntaSimNaoRadioListFieldProps<T>>) {
  const { label, nameOutro, hideOutrosFieldRadioOptions, onOutroFieldBlur, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  if (nameOutro) {
    return (
      <PerguntaSimNaoOutroRadioListField
        label={<span>“{label}”</span>}
        labelStyle={styles.label}
        nameOutro={nameOutro}
        hideOutrosFieldRadioOptions={hideOutrosFieldRadioOptions}
        onOutroFieldBlur={onOutroFieldBlur}
        {...rest}
      />
    )
  }

  return <SimNaoRadioGroupListField label={<span>“{label}”</span>} labelStyle={styles.label} {...rest} />
}

const createStyles = (theme: Theme) => ({
  label: css`
    color: ${theme.pallete.primary.main};
  `,
})
